import "./AboutUs.module.css";
import Intestazione from "@/reusable_sections/Header";
import IlCuoreDiSciacca from "./sections/IlCuoreDiSciacca";
import LaQualitaDegliIngredienti from "./sections/LaQualitaDegliIngredienti";
import PieDiPagina from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Intestazione />
      <IlCuoreDiSciacca />
      <LaQualitaDegliIngredienti />
      <PieDiPagina />
    </div>;
}